"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.color = void 0;
var chroma_js_1 = __importDefault(require("chroma-js"));
var color = {
    RGBtoHSLA: function (r, g, b, alpha) {
        var rNorm = r / 255;
        var gNorm = g / 255;
        var bNorm = b / 255;
        var min = Math.min(rNorm, gNorm, bNorm);
        var max = Math.max(rNorm, gNorm, bNorm);
        var h = 0, s = 0, l = (max + min) / 2;
        if (max !== min) {
            var d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            if (max === rNorm)
                h = (gNorm - bNorm) / d + (gNorm < bNorm ? 6 : 0);
            else if (max === gNorm)
                h = (bNorm - rNorm) / d + 2;
            else
                h = (rNorm - gNorm) / d + 4;
            h /= 6;
        }
        s = +(s * 100).toFixed(1);
        l = +(l * 100).toFixed(1);
        h = +(h * 360).toFixed(1);
        if (alpha !== undefined) {
            return "hsla(".concat(h, ", ").concat(s, "%, ").concat(l, "%, ").concat(alpha, ")");
        }
        return "hsl(".concat(h, ", ").concat(s, "%, ").concat(l, "%)");
    },
    hexToHSLA: function (hex, alpha) {
        var localHex = hex.replace("#", "");
        var r = parseInt(localHex.substring(0, 2), 16);
        var g = parseInt(localHex.substring(2, 4), 16);
        var b = parseInt(localHex.substring(4, 6), 16);
        var rNorm = r / 255;
        var gNorm = g / 255;
        var bNorm = b / 255;
        var min = Math.min(rNorm, gNorm, bNorm);
        var max = Math.max(rNorm, gNorm, bNorm);
        var l = (min + max) / 2;
        var s = 0;
        if (max !== min) {
            s = l < 0.5 ? (max - min) / (max + min) : (max - min) / (2.0 - max - min);
        }
        var h = 0;
        if (max !== min) {
            if (max === rNorm) {
                h = (gNorm - bNorm) / (max - min);
            }
            else if (max === gNorm) {
                h = 2.0 + (bNorm - rNorm) / (max - min);
            }
            else {
                h = 4.0 + (rNorm - gNorm) / (max - min);
            }
        }
        h = Math.round(h * 60);
        if (h < 0) {
            h += 360;
        }
        s = +(s * 100).toFixed(1);
        l = +(l * 100).toFixed(1);
        if (alpha !== undefined) {
            return "hsla(".concat(h, ", ").concat(s, "%, ").concat(l, "%, ").concat(alpha, ")");
        }
        return "hsl(".concat(h, ", ").concat(s, "%, ").concat(l, "%)");
    },
    convertToHSLA: function (tcolor, alpha) {
        function isHexColor(tcolor) {
            return /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(tcolor);
        }
        function isRGBColor(tcolor) {
            return /^rgb(a)?\(([\d, %]+)\)$/.test(tcolor);
        }
        function isHSLAColor(tcolor) {
            return /^hsl(a)?\([\d., %]+\)$/.test(tcolor);
        }
        if (isHSLAColor(tcolor)) {
            return tcolor;
        }
        if (isHexColor(tcolor)) {
            return color.hexToHSLA(tcolor, alpha);
        }
        if (isRGBColor(tcolor)) {
            var rgb = tcolor; // Force TypeScript to accept the type
            var _a = rgb.match(/\d+/g).map(Number), r = _a[0], g = _a[1], b = _a[2];
            return color.RGBtoHSLA(r, g, b, alpha);
        }
        throw new Error("Unsupported color format: ".concat(color));
    },
    lighten: function (hslaColor) {
        try {
            var regex = /hsla?\((\d+),\s*([\d.]+)%,\s*([\d.]+)%(?:,\s*([\d.]+))?\)/;
            var matches = hslaColor.match(regex);
            if (!matches) {
                throw new Error("Invalid HSLA color");
            }
            var h = parseInt(matches[1]);
            var s = parseFloat(matches[2]);
            var l = Math.min(100, parseFloat(matches[3]) + 10);
            var a = matches[4] !== undefined ? parseFloat(matches[4]) : undefined;
            if (a !== undefined) {
                return "hsla(".concat(h, ", ").concat(s, "%, ").concat(l, "%, ").concat(a, ")");
            }
            else {
                return "hsl(".concat(h, ", ").concat(s, "%, ").concat(l, "%)");
            }
        }
        catch (error) {
            return "hsla(0, 0%, 0%, 1)";
        }
    },
    darken: function (hslaColor) {
        try {
            var regex = /hsla?\((\d+),\s*([\d.]+)%,\s*([\d.]+)%(?:,\s*([\d.]+))?\)/;
            var matches = hslaColor.match(regex);
            if (!matches) {
                throw new Error("Invalid HSLA color");
            }
            var h = parseInt(matches[1]);
            var s = parseFloat(matches[2]);
            var l = Math.max(0, parseFloat(matches[3]) - 10);
            var a = matches[4] !== undefined ? parseFloat(matches[4]) : undefined;
            if (a !== undefined) {
                return "hsla(".concat(h, ", ").concat(s, "%, ").concat(l, "%, ").concat(a, ")");
            }
            else {
                return "hsl(".concat(h, ", ").concat(s, "%, ").concat(l, "%)");
            }
        }
        catch (error) {
            return "hsla(0, 0%, 0%, 1)";
        }
    },
    getTextColorFromBackground: function (backgroundColor) {
        // Convert HSLA color to HSL values
        var regex = /hsla\((\d+),\s*([\d.]+)%,\s*([\d.]+)%,\s*([\d.]+)\)/;
        var matches = backgroundColor.match(regex);
        if (!matches) {
            throw new Error("Invalid HSLA color");
        }
        var h = parseInt(matches[1]);
        var s = parseFloat(matches[2]) / 100;
        var l = parseFloat(matches[3]) / 100;
        var a = parseFloat(matches[4]);
        // Choose text color based on lightness and opacity
        var opacityAdjustedL = 1 - a + a * l;
        var textColor = opacityAdjustedL > 0.5 ? "hsla(0, 0%, 0%, 1)" : "hsla(0, 0%, 100%, 1)";
        return textColor;
    },
    getPerceivedColor: function (hsla) {
        var color = (0, chroma_js_1.default)(hsla);
        var hue = color.get("hsl.h");
        var lightness = color.get("hsl.l");
        var dominantColor = "";
        if (hue <= 30 || hue > 330) {
            dominantColor = "red";
        }
        else if (hue > 30 && hue <= 90) {
            dominantColor = "yellow";
        }
        else if (hue > 90 && hue <= 150) {
            dominantColor = "green";
        }
        else if (hue > 150 && hue <= 210) {
            dominantColor = "cyan";
        }
        else if (hue > 210 && hue <= 270) {
            dominantColor = "blue";
        }
        else if (hue > 270 && hue <= 330) {
            dominantColor = "magenta";
        }
        var perceivedBrightness = lightness < 0.5 ? "dark" : "light";
        return "".concat(perceivedBrightness, " ").concat(dominantColor);
    },
    hslaToHex: function (hsla) {
        // Parse the HSLA color
        var matches = hsla.match(/hsla\((\d+), (\d+)%?, (\d+)%?, (\d+(\.\d+)?)\)/);
        if (!matches) {
            throw new Error("Invalid HSLA color");
        }
        var h = Number(matches[1]);
        var s = Number(matches[2]);
        var l = Number(matches[3]);
        // Convert HSL to HEX ignoring alpha
        l /= 100;
        var a = (s * Math.min(l, 1 - l)) / 100;
        var f = function (n) {
            var k = (n + h / 30) % 12;
            var color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
            return Math.round(255 * color)
                .toString(16)
                .padStart(2, "0");
        };
        return "#".concat(f(0)).concat(f(8)).concat(f(4));
    },
};
exports.color = color;
